// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Byoh","left":"styles_left__SoWrc","desktopActions":"styles_desktopActions__1BLIT","title":"styles_title__1gOY6"};